var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    position: 'absolute',
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    left: _vm.left + 'px',
    top: _vm.top + 'px',
  })},[_vm._t("crossInfoPanel",null,{"panelInfo":{
      videoUrl: _vm.videoUrl,
      armId: _vm.id,
      lineDir: _vm.lineDir,
      coordinates: _vm.devicePosition,
      center: _vm.center,
    }})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }